export const CURRENCY_OPTIONS = [
  'USD',
  'EUR',
  'AED',
  'GBP',
  'RUB',
  'AUD',
  'UAH',
  'BRL',
  'BYN',
  'CZK',
  'IDR',
  'INR',
  'KZT',
  'MXN',
  'PLN',
  'TRY',
] as const;

export const CURRENCY_SYMBOLS: Record<(typeof CURRENCY_OPTIONS)[number], string> = {
  AED: 'د.إ',
  AUD: '$',
  BRL: 'R$',
  BYN: 'Br',
  CZK: 'Kč',
  EUR: '€',
  GBP: '£',
  IDR: 'Rp',
  INR: '₹',
  KZT: '₸',
  MXN: 'MXN',
  PLN: 'zł',
  RUB: '₽',
  TRY: '₺',
  UAH: '₴',
  USD: '$',
};
